import React, { useState } from 'react';
import "./App.css";
import Data from "./Datas.json";

function App() {
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const [classNam, setclassNam] = useState("prev");
    const [Dateint, setdateint] = useState([{ newMoon: null, first_quarter: null, full_moon: null, third_quarter: null }]);
    const [Year, setYear] = useState(2022);
    const option_int = (e) => {
        setdateint([{ newMoon: null, first_quarter: null, full_moon: null, third_quarter: null }]);
        let def_date = new Date("08/01/1951");
        let new_moon = new Date("08/01/1951");
        for (var i = 1; i < 5000; i++) {
            setclassNam("table_data");
            new_moon.setDate(def_date.getDate() + i * 29.53059);
            let temp_moon = new_moon;
            let first_q = new Date(new_moon);
            let full_moon = new Date(new_moon);
            let third_moon = new Date(new_moon);
            first_q.setDate(new_moon.getDate() + 7);
            full_moon.setDate(new_moon.getDate() + 15);
            if (Number(Year) === Number(new_moon.getFullYear())) {
                setdateint(ret => [...ret, {
                    newMoon: days[temp_moon.getDay()] + ', ' + temp_moon.getDate() + " " + months[temp_moon.getMonth()],
                    first_quarter: days[first_q.getDay()] + ', ' + first_q.getDate() + " " + months[first_q.getMonth()],
                    full_moon: days[full_moon.getDay()] + ', ' + full_moon.getDate() + " " + months[full_moon.getMonth()],
                    third_quarter: days[third_moon.getDay()] + ', ' + third_moon.getDate() + " " + months[third_moon.getMonth()]
                }])
            }
            new_moon = new Date("08/01/1951");
        }
    }
    return (
        <div>
            <header>
                <div className='navbar'>
                    Moon Phase Calculator
                </div>
            </header>
            <section className='section'>
                <div className='bodycontainer'> Do you want to know the phase of the Moon in past, present or future. If yes, then this is the perfect place for you.  </div>
                <div className='datacontainer'>

                    <span>
                        <span>Showing Moon Phases for Year: </span>
                        <input className='input_data' type="number" min="1952" max="2350" value={Year} onChange={(e) => setYear(e.target.value)}></input>
                        <button className='input_btn' onClick={() => option_int()}>Fire it</button></span>
                </div>
            </section>
           
            <section className={classNam}>
                <table id="table">
                    <thead>
                        <tr>
                            <th>New Moon &#127761;</th>
                            <th>First Quarter &#127763;</th>
                            <th>Full Moon &#127765;</th>
                            <th>Third Quarter &#127767;</th>
                        </tr></thead>
                    <tbody>

                        {Dateint.map(data => {
                            return <tr key={data.newMoon}>{data.newMoon !== null ? <React.Fragment>
                                <td>{data.newMoon}</td>
                                <td>{data.first_quarter}</td>
                                <td>{data.full_moon}</td>
                                <td>{data.third_quarter}</td>
                            </React.Fragment> : null}</tr>
                        })}</tbody></table>
            </section>
            <section className='moonphases'>
                {Data.map(data => {
                    return (
                        <div className='moonphasecont' key={data.Desc}>
                            <div >
                            <div className='header_div'>{data.phase}</div>
                            <div className='desc_div'>{data.Desc }</div></div>
                            <div className='img_div'>
                            <img  src={data.image} alt="moonphases" className='img_'/>
                            </div>
                            
                        </div>
                        
                    )
                })}
            </section>
            <h4 className="table__"><i><u>Where and When to see the Moon</u></i></h4>
            <section className="table_data">
           
                <table>
                <tbody>
                    <tr>
                        <th scope="row"><em>New Moon</em></th>
                        <td>Around sunrise</td>
                        <td>Around noon</td>
                        <td>Around sunset</td>
                    </tr>
                    <tr>
                        <th scope="row">Waxing Crescent</th>
                        <td>Between sunrise and noon</td>
                        <td>Afternoon</td>
                        <td>Between sunset and midnight</td>
                    </tr>
                    <tr>
                        <th scope="row"><em>First Quarter</em></th>
                        <td>Around noon</td>
                        <td>Around sunset</td>
                        <td>Around midnight</td>
                    </tr>
                    <tr>
                        <th scope="row">Waxing Gibbous</th>
                        <td>Between noon and sunset</td>
                        <td>Evening</td>
                        <td>Between midnight and sunrise</td>
                    </tr>
                    <tr>
                        <th scope="row"><em>Full Moon</em></th>
                        <td>Around sunset</td>
                        <td>Around midnight</td>
                        <td>Around sunrise</td>
                    </tr>
                    <tr>
                        <th scope="row">Waning Gibbous</th>
                        <td>Between sunset and midnight</td>
                        <td>Early morning</td>
                        <td>Between sunrise and noon</td>
                    </tr>
                    <tr>
                        <th scope="row"><em>Last Quarter</em></th>
                        <td>Around midnight</td>
                        <td>Around sunrise</td>
                        <td>Around noon</td>
                    </tr>
                    <tr>
                        <th scope="row">Waning Crescent</th>
                        <td>Between midnight and sunrise</td>
                        <td>Morning</td>
                        <td>Between noon and sunset</td>
                    </tr>
                </tbody><thead>
                    <tr>
                        <th>Phase</th>
                        <th>Rises Near the East</th>
                        <th>Highest in the Sky</th>
                        <th>Sets Near the West</th>
                    </tr>
                </thead>
                </table>
            </section>
            <footer className='foots'>
           <div style={{padding:"10px 0"}}>Please Note: This App displays the approximate Moon phases. Moon rise/set times are available from the U.S. Naval Observatory.</div>
           <div>This App has been created, maintained and owned by Zeroexpdevs. <a href='mailto:zeroexpdevs@gmail.com'>Contact</a></div>

            </footer>
        </div>
    )
}

export default App